// src/pages/personal/platforms/TelegramPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import TelegramSection from './TelegramSection/TelegramSection';

const TelegramPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <TelegramSection />
    </AdaptiveLayout>
  );
};

export default TelegramPage;